import { GUARD_TUNING_DEFAULT, type GuardTuning } from '../config/constants';
import { getSetting, setSetting } from '../settings/userSettings';

/**
 * Typed adapter for the guard-recognition tunables, persisted via the central user-settings
 * store. The store already sanitizes each field to its slider range. Mirrors `pellSettings.ts`.
 */
export function loadGuardTuning(): GuardTuning {
  return { ...GUARD_TUNING_DEFAULT, ...getSetting('guardTuning') };
}

export function saveGuardTuning(tuning: GuardTuning): void {
  setSetting('guardTuning', tuning);
}
